export default function({ state, output }) {
  if (state.get('client.user')) {
    output.success()
  } else {
    output.error()
  }
}



// WEBPACK FOOTER //
// ./src/modules/user/actions/checkLoggedIn.js